const topics = [
  { label: '#斗罗大陆', count: '12.8万讨论' },
  { label: '#完美世界', count: '10.3万讨论' },
  { label: '#国漫崛起', count: '8.6万讨论' },
  { label: '#一人之下', count: '7.9万讨论' },
  { label: '#新番推荐', count: '6.5万讨论' },
  { label: '#漫画推荐', count: '5.8万讨论' },
  { label: '#斗破苍穹', count: '5.2万讨论' },
  { label: '#壁纸分享', count: '4.1万讨论' },
  { label: '#剧情讨论', count: '3.7万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            话题标签
          </h2>
          <p className="text-sm text-foreground-500">社区热议话题，加入讨论分享你的看法</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((item) => (
            <a
              key={item.label}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById('ranking');
                if (el) {
                  const top = el.getBoundingClientRect().top + window.scrollY - 80;
                  window.scrollTo({ top, behavior: 'smooth' });
                }
              }}
              className="group bg-background-50 rounded-full px-5 py-2.5 flex items-center gap-2 cursor-pointer hover:bg-primary-50/70 transition-colors duration-200"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}